"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _redux = require("redux");

var _reduxForm = require("redux-form");

var _reactRouterRedux = require("react-router-redux");

var _formNormalization = require("utils/formNormalization");

var _formNormalization2 = _interopRequireDefault(_formNormalization);

var _formPlugin = require("utils/formPlugin");

var _formPlugin2 = _interopRequireDefault(_formPlugin);

var _request = require("./request");

var _request2 = _interopRequireDefault(_request);

var _auth = require("./auth");

var _auth2 = _interopRequireDefault(_auth);

var _user = require("./user");

var _user2 = _interopRequireDefault(_user);

var _route = require("./route");

var _route2 = _interopRequireDefault(_route);

var _assets = require("./assets");

var _assets2 = _interopRequireDefault(_assets);

var _facets = require("./facets");

var _facets2 = _interopRequireDefault(_facets);

var _assetSettings = require("./assetSettings");

var _assetSettings2 = _interopRequireDefault(_assetSettings);

var _assetDownloads = require("./assetDownloads");

var _assetDownloads2 = _interopRequireDefault(_assetDownloads);

var _subscriptions = require("./subscriptions");

var _subscriptions2 = _interopRequireDefault(_subscriptions);

var _payments = require("./payments");

var _payments2 = _interopRequireDefault(_payments);

var _customer = require("./customer");

var _customer2 = _interopRequireDefault(_customer);

var _billing = require("./billing");

var _billing2 = _interopRequireDefault(_billing);

var _activity = require("./activity");

var _activity2 = _interopRequireDefault(_activity);

var _license = require("./license");

var _license2 = _interopRequireDefault(_license);

var _search = require("./search");

var _search2 = _interopRequireDefault(_search);

var _server = require("./server");

var _server2 = _interopRequireDefault(_server);

var _pack = require("./pack");

var _pack2 = _interopRequireDefault(_pack);

var _packs = require("./packs");

var _packs2 = _interopRequireDefault(_packs);

var _topups = require("./topups");

var _topups2 = _interopRequireDefault(_topups);

var _vat = require("./vat");

var _vat2 = _interopRequireDefault(_vat);

var _softwares = require("./softwares");

var _softwares2 = _interopRequireDefault(_softwares);

var _zendesk = require("./zendesk");

var _zendesk2 = _interopRequireDefault(_zendesk);

var _news = require("./news");

var _news2 = _interopRequireDefault(_news);

var _companyLogos = require("./companyLogos");

var _companyLogos2 = _interopRequireDefault(_companyLogos);

var _email = require("./email");

var _email2 = _interopRequireDefault(_email);

var _applications = require("./applications");

var _applications2 = _interopRequireDefault(_applications);

var _academicUsers = require("./academicUsers");

var _academicUsers2 = _interopRequireDefault(_academicUsers);

var _notifications = require("./notifications");

var _notifications2 = _interopRequireDefault(_notifications);

var _settings = require("./settings");

var _settings2 = _interopRequireDefault(_settings);

var _gallery = require("./gallery");

var _gallery2 = _interopRequireDefault(_gallery);

var _hubspot = require("./hubspot");

var _hubspot2 = _interopRequireDefault(_hubspot);

var _analytics = require("./analytics");

var _analytics2 = _interopRequireDefault(_analytics);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _redux.combineReducers)({
  analytics: _analytics2.default,
  request: _request2.default,
  auth: _auth2.default,
  user: _user2.default,
  assets: _assets2.default,
  facets: _facets2.default,
  assetSettings: _assetSettings2.default,
  assetDownloads: _assetDownloads2.default,
  subscriptions: _subscriptions2.default,
  payments: _payments2.default,
  customer: _customer2.default,
  billing: _billing2.default,
  activity: _activity2.default,
  license: _license2.default,
  pack: _pack2.default,
  search: _search2.default,
  server: _server2.default,
  packs: _packs2.default,
  topups: _topups2.default,
  vat: _vat2.default,
  softwares: _softwares2.default,
  zendesk: _zendesk2.default,
  news: _news2.default,
  email: _email2.default,
  applications: _applications2.default,
  academicUsers: _academicUsers2.default,
  notifications: _notifications2.default,
  settings: _settings2.default,
  gallery: _gallery2.default,
  hubspot: _hubspot2.default,
  companyLogos: _companyLogos2.default,
  form: _reduxForm.reducer.normalize(_formNormalization2.default).plugin(_formPlugin2.default),
  routing: _reactRouterRedux.routerReducer
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/reducer.js
// module id = 2163
// module chunks = 0